module.exports = __webpack_public_path__ + "img/underWriteMeLogo3.3d47ad70.png";